import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSmartModalComponent, NgxSmartModalService } from 'ngx-smart-modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { AbstractBaseComponent } from 'src/app/model/AbstractBaseComponent';
import { AddUpdateUtenteCommand } from 'src/app/model/command-model';
import { SharedService } from 'src/app/shared/shared.service';

import { SelectDTO } from './../../../model/newModel';

@Component({
  selector: 'app-modifica-profilo',
  templateUrl: './modifica-profilo.component.html',
  styleUrls: ['./modifica-profilo.component.css'],
})
export class ModificaProfiloComponent
  extends AbstractBaseComponent
  implements AfterViewInit, OnInit, OnDestroy {
  corsiLaurea: SelectDTO[];
  modifica: AddUpdateUtenteCommand;
  modificaForm: FormGroup;
  submitted = false;
  counts: any;
  contatore = 0;

  constructor(
    public router: Router,
    private spinner: NgxSpinnerService,
    public ngxSmartModalService: NgxSmartModalService,
    private formBuilder: FormBuilder,
    private sharedService: SharedService
  ) {
    super();
  }

  loadCorsiLaurea() {
    this.sharedService.selectCorsiLaurea().subscribe(
      (result) => {
        this.corsiLaurea = result.list;
      },
      (error) => {
        console.log('Errore selectCorsiLaurea');
      }
    );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  verifyFile(file: File) {
    if (
      file &&
      file.name.indexOf('.png') <= 0 &&
      file.name.indexOf('.jpg') <= 0 &&
      file.name.indexOf('.jpeg') <= 0
    ) {
      this.sharedService.openKoModal();
    } else {
      // aspetto 5 secondi e ricarico chiamando il backend per recuperare la nuova immagine
      setTimeout(() => {
        if (this.contatore === 0) {
          this.sharedService.getFotoProfilo(this.currentUser.id).subscribe(
            (result) => {
              const reader = new FileReader();
              const s = reader.readAsDataURL(result);
              this.currentUser.fotoProfiloUtente = s;
              this.currentUser.haveFotoProfiloUtente = true;

              sessionStorage.setItem(
                'currentUser',
                JSON.stringify(this.currentUser)
              );
              this.sharedService.openOkModal();
              this.modalSubscribe = this.ngxSmartModalService
                .getModal('okModal')
                .onClose.subscribe((modal: NgxSmartModalComponent) => {
                  sessionStorage.clear();
                  localStorage.clear();
                  this.router.navigate(['/login']);
                });
            },
            (error) => {
              this.sharedService.openKoModal();
            }
          );
          this.contatore++;
        }
      }, 1000);
    }
  }

  ngOnInit(): void {
    this.contatore = 0;
    super.ngOnInit();
    this.loadCorsiLaurea();
    this.modificaForm = this.formBuilder.group({
      idUtente: ['', Validators.required],
      idCorsoLaurea: ['', Validators.required],
      idStudente: ['', Validators.required],
      nomeStudente: ['', Validators.required],
      cognomeStudente: ['', Validators.required],
      emailStudente: ['', Validators.required],
      matricola: ['', Validators.required],
      password: ['', Validators.minLength(8)],
      telefono: [''],
    });

    this.f.idUtente.setValue(this.currentUser.id);
    this.f.idStudente.setValue('' + this.student.id);
    this.f.nomeStudente.setValue(this.student.nome);
    this.f.cognomeStudente.setValue(this.student.cognome);
    this.f.emailStudente.setValue(this.student.email);
    this.f.matricola.setValue(this.student.matricola);
    this.f.idCorsoLaurea.setValue('' + this.student.corsoLaurea.id);
  }

  get f() {
    return this.modificaForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    this.spinner.show();
    // stop here if form is invalid
    if (this.modificaForm.invalid) {
      this.spinner.hide();
      const text = 'Form non valido!';
      this.sharedService.openWarningModal(text);
    } else {
      this.modifica = new AddUpdateUtenteCommand();
      this.modifica.id = this.f.idUtente.value;
      this.modifica.idStudente = this.f.idStudente.value;
      this.modifica.nomeStudente = this.f.nomeStudente.value;
      this.modifica.cognomeStudente = this.f.cognomeStudente.value;
      this.modifica.emailStudente = this.f.emailStudente.value;
      this.modifica.idGruppo = this.currentUser.gruppo.id;
      this.modifica.idCorsoLaurea = this.f.idCorsoLaurea.value;
      this.modifica.matricola = this.f.matricola.value;
      this.modifica.idSessioneOla = this.student.sessioneOla.id;
      this.modifica.withOtherUpdate = true;
      this.modifica.password = this.f.password.value; // TODO SE LA PASSWORD E' VUOTA ALLORA NON VIENE AGGIORNATA
      this.sharedService.update(this.modifica).subscribe(
        (result) => {
          this.spinner.hide();
          this.sharedService.openOkModal();
          this.modalSubscribe = this.ngxSmartModalService
            .getModal('okModal')
            .onClose.subscribe((modal: NgxSmartModalComponent) => {
              sessionStorage.clear();
              localStorage.clear();
              this.router.navigate(['/login']);
            });
        },
        (error) => {
          this.spinner.hide();
          this.sharedService.openKoModal();
        }
      );
    }
  }
}
